<template>
  <b-card no-body class="flex-container grid-stack-item-content label-modal">
    <div slot="header">
      <window-header :cmp-title="features[currentFeatureIndex]['name']+' - '+dateCreated" :widget-name="features[currentFeatureIndex]['id']+'drone_view'"></window-header>
    </div>
    <div class="w-100">
      <img class="w-100"  :src="imgSrc" />
    </div>
    <window-footer></window-footer>
  </b-card>

</template>

<script>
  import WindowHeader from '../common/WindowHeader'
  import WindowFooter from '../common/WindowFooter'
  export default {
    name: 'DroneImageView',
    components: {WindowHeader, WindowFooter},
    props: {
      features: null
    },
    data () {
      return {
        currentFeatureIndex: 0
      }
    },
    computed: {
      imgSrc () {
        return `/api/layers/drone-img-thumbnail/?id=${this.features[this.currentFeatureIndex]['id']}&img_type=light`
      },
      dateCreated () {
        return new Date(this.features[this.currentFeatureIndex]['date_created']).toLocaleDateString()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/DroneImageView.vue